// Taşeron portalı — self-profil (`GET /supplier/me`) okuma hook'u (api-contract §18.2).
//
// Header'da "Taşeron Portalı | Firma" ve profil menüsünde ad-soyad için kullanılır.
// Oturum açık (RequireAuth altı, terminal token) varsayılır; `enabled` yalnız
// **supplier** principal + **aktif firma** varken çağırır (transit `workspace_select`
// token'da companyId yok — yanlış principal/aktif-firmasız çağrı yapılmaz; §18 scope
// izolasyonu). Anahtar aktif firmayı içerdiğinden switcher ile firma değişince otomatik
// yeniden çekilir. 401 → API client mevcut refresh rotasyonu/oturum-düşürme akışını
// yürütür (yeni akış icat edilmez); 4xx'te retry yok. Profil nadiren değişir → uzun staleTime.

import { type SupplierMeDto, profileApi, useAuthStore } from '@isgportal/shared';
import { useQuery } from '@tanstack/react-query';
import { meKeys } from './meKeys';

export interface UseSupplierMeResult {
  /** Giriş yapan taşeron personelinin profili (yüklenene / hata olana dek `undefined`). */
  me: SupplierMeDto | undefined;
  isPending: boolean;
}

export function useSupplierMe(): UseSupplierMeResult {
  const principal = useAuthStore((s) => s.principal);
  const query = useQuery({
    queryKey: meKeys.me(principal?.companyId, principal?.supplierUserId),
    queryFn: () => profileApi.getSupplierMe(),
    enabled: principal?.principalType === 'supplier' && principal.companyId != null,
    retry: false,
    staleTime: 5 * 60_000,
  });

  return { me: query.data, isPending: query.isPending };
}
